import * as d3 from 'd3';

export const round = (number: number, digit = 2, exact = true): number => {
  // eslint-disable-next-line no-restricted-properties
  let multiple = Math.pow(10, digit);
  let n = Math.round(number * multiple);
  if (!exact) {
    let count = digit;
    // eslint-disable-next-line no-plusplus
    while (count-- > 1) {
      if (n % 10 === 0) {
        n /= 10;
        multiple /= 10;
      } else {
        break;
      }
    }
  }
  return n / multiple;
};

export const roundAndExponent = (num: number, roundDigit = 2, expDigit = 3): number => {
  let n = round(num, roundDigit, false);
  // eslint-disable-next-line no-restricted-properties
  if (Math.abs(n) >= Math.pow(10, expDigit + 1)) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    n = parseFloat(d3.format(`.${expDigit}~e`)(n));
  }
  return n;
};
